import axios from "axios"

const GOOGLE_SHEET_URL = `https://script.google.com/macros/s/AKfycbyT9xBNHEilohPrzNIjSiY5qNTDnQuWX_1JwsDaZjWJKcifuvVR/exec`

export default function apiCall(url, method = "GET", body = {}, headers = {}) {
	return axios({
		url,
		method,
		headers: {
			"content-type": "application/json",
			...headers
		},
		data: body
	})
}

export async function addContact(contact) {
	const body = contact
	const url =
		process.env.NODE_ENV === "production"
			? "https://app.uprise.co/api/newsletter/subscribe"
			: "http://localhost:8080/api/newsletter/subscribe"

	return await apiCall(url, "POST", body)
}

export function saveToGoogleSheet(data = {}) {
	const {
		firstName = "",
		lastName = "",
		email = "",
		company = "",
		areaCode = "+61",
		phone = "",
		employees = 0,
		referrer = "google"
	} = data

	const url = `${GOOGLE_SHEET_URL}?Date=${encodeURIComponent(
		new Date().toUTCString()
	)}&FirstName=${encodeURIComponent(firstName)}&LastName=${encodeURIComponent(lastName)}&Email=${encodeURIComponent(
		email
	)}&Company=${encodeURIComponent(company)}&AreaCode=${encodeURIComponent(areaCode)}&Phone=${encodeURIComponent(
		phone
	)}&Employees=${encodeURIComponent(employees)}&Referrer=${encodeURIComponent(referrer)}`

	return fetch(url)
}
